export default {"src":"/uk/_next/static/media/blob-deny.c5f67330.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};